export function getAllResources(axiosPrivate) {
  return axiosPrivate.get('/resources')
}

export function getResourceById(axiosPrivate, id) {
  return axiosPrivate.get(`/resources/${id}`)
}

export function createResource(axiosPrivate, data) {
  return axiosPrivate.post('/resources', data)
}

export function updateResourceById(axiosPrivate, id, data) {
  return axiosPrivate.put(`/resources/${id}`, data)
}

export function deleteResource(axiosPrivate, id) {
  return axiosPrivate.delete(`/resources/${id}`)
}
